import type { TablePager } from '@fukuri-admins/ui/common/Table/Pager';
import type { ComponentProps } from 'react';

type Args = {
  /** 現在のページ番号（1始まり） */
  currentPage: number;
  /** 総ページ数 */
  totalPage: number;
  /** 総件数 */
  totalCount: number;
  /** 現在ページに表示する行データの配列 */
  rows: unknown[];
  /** ページ変更コールバック */
  onPageChange: (page: number) => void;
};

/** TablePager（ui/common/Table/Pager）に渡す Props（className 除く） */
type PagerProps = Omit<ComponentProps<typeof TablePager>, 'className'>;

type IGeneratePagerProps = (args: Args) => PagerProps;

/**
 * TablePager（ui/common/Table/Pager）に渡す Props（className 除く）を生成する。
 *
 * API レスポンスヘッダーに 1 ページあたりの件数（per-page）が含まれないため、
 * 最終ページでは総件数から 1 ページあたりの件数を逆算する。
 * - 総ページ数が 1 以下、または最終ページより前のページ: 行データの配列の件数をそのまま使う
 * - 最終ページ: `(totalCount - rows.length) / (totalPage - 1)` で 1 ページあたりの件数を逆算する
 */
export const generatePagerProps: IGeneratePagerProps = ({
  currentPage,
  totalPage,
  totalCount,
  rows,
  onPageChange,
}) => {
  const dataLength = rows.length;
  const itemCount =
    totalPage <= 1 || currentPage < totalPage
      ? dataLength
      : Math.round((totalCount - dataLength) / (totalPage - 1));

  return { currentPage, totalPage, itemCount, totalCount, onPageChange };
};
